/*
 * Ensures the cart receives the variant matching the customer's selected
 * options. Guards against the hidden master <select name="id"> drifting out of
 * sync with the visible variant inputs (e.g. after bfcache restore or browser
 * autofill), which could otherwise add the wrong variant to the cart.
 */
(function () {
  var FORM_SELECTOR = 'form.product-single__form, form[action*="/cart/add"]';

  function syncVariantId(form) {
    if (!form) return;
    var master = form.querySelector('[data-product-select], select[name="id"]');
    var jsonEl = form.querySelector('[data-variant-json]');
    if (!master || !jsonEl) return;

    var selected = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.matches || !el.matches('[data-variant-input]')) return;
      var index = el.dataset.index;
      if (!index) return;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.checked) selected[index] = el.value;
      } else {
        selected[index] = el.value;
      }
    });

    var keys = Object.keys(selected);
    if (!keys.length) return;

    var variants;
    try { variants = JSON.parse(jsonEl.value || jsonEl.textContent); }
    catch (e) { return; }
    if (!variants || !variants.length) return;

    var match = variants.filter(function (v) {
      return keys.every(function (k) { return String(v[k]) === String(selected[k]); });
    })[0];
    if (!match) return;

    if (!master.querySelector('option[value="' + match.id + '"]')) {
      var opt = document.createElement('option');
      opt.value = match.id;
      opt.textContent = match.title || match.id;
      master.appendChild(opt);
    }
    if (String(master.value) !== String(match.id)) {
      master.value = match.id;
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches(FORM_SELECTOR)) {
      try { syncVariantId(form); } catch (err) {}
    }
  }, true);

  function initForms() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (f) {
      f.setAttribute('autocomplete', 'off');
    });
  }

  if (document.readyState !== 'loading') initForms();
  else document.addEventListener('DOMContentLoaded', initForms);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll(FORM_SELECTOR).forEach(syncVariantId);
    }
  });
})();
